import React, { useState } from 'react'
import { Link } from 'gatsby'

import { HamburgerSpin } from 'react-animated-burgers'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import logoActividad from '../../../assets/images/rombo-puntos.png'
import iconoInicio from '../../../assets/images/nav-menu-icons/icon-home.svg'
import iconoPremios from '../../../assets/images/nav-menu-icons/icon-premios.svg'
import iconoInstrucciones from '../../../assets/images/nav-menu-icons/icon-instrucciones.svg'
import iconoJugar from '../../../assets/images/nav-menu-icons/icon-jugar.svg'
import iconoPerfil from '../../../assets/images/nav-menu-icons/icon-perfil.svg'
import iconoTopJugadoras from '../../../assets/images/nav-menu-icons/icon-topjugadoras.svg'
import iconoPreguntasFrecuentes from '../../../assets/images/nav-menu-icons/icon-preguntasfrecuentes.svg'

import { jsonToHash } from '../../../utils/crypto'
import getUserInfo from '../../../utils/getUserInfo'

import './nav-menu.scss'
const LOCALE = process.env.LOCALE

const NavMenu = ({ isMobile }) => {
  const [isActive, setIsActive] = useState(false)
  const [activeMenu, setActiveMenu] = useState(false)
  const userInfo = getUserInfo()

  const toggleButton = async evt => {
    if (evt) {
      let text = evt.target?.innerText
      if (text) {
        if (text) {
          pushEventData({
            event: 'Interacciones_Menú_UCole',
            label: text,
            user_data: userInfo && [
              await jsonToHash({
                nombre: userInfo.name,
                apellido: userInfo.lastName,
                celular: userInfo.cellPhone,
                correo: userInfo.email,
                ciudad: userInfo.location.cityName,
                departamento: userInfo.location.countryStateName,
                pais: userInfo.countryName,
              }),
            ],
            log_status: userInfo ? 'Yes' : 'Not',
          })
        }
      }
    }

    setIsActive(prevState => !prevState)
    setActiveMenu(prevState => !prevState)
  }

  const menuOptions = () => {
    return (
      <ul className="f-nav-menu__list">
        <li className="f-nav-menu__item">
          <Link
            to="/"
            className="f-nav-menu__link"
            activeClassName="--active"
            onClick={toggleButton}
          >
            <img className="f-nav-menu__link__icon" src={iconoInicio} />
            Inicio
          </Link>
        </li>
        <li className="f-nav-menu__item">
          <Link
            to="/premios"
            className="f-nav-menu__link"
            activeClassName="--active"
            onClick={toggleButton}
          >
            <img className="f-nav-menu__link__icon" src={iconoPremios} />
            Premios
          </Link>
        </li>
        <li className="f-nav-menu__item">
          <Link
            to="/instrucciones"
            className="f-nav-menu__link"
            activeClassName="--active"
            onClick={toggleButton}
          >
            <img className="f-nav-menu__link__icon" src={iconoInstrucciones} />
            Instrucciones
          </Link>
        </li>
        <li className="f-nav-menu__item">
          <Link
            to="/jugar"
            className="f-nav-menu__link"
            activeClassName="--active"
            onClick={toggleButton}
          >
            <img className="f-nav-menu__link__icon" src={iconoJugar} />
            Jugar
          </Link>
        </li>
        <li className="f-nav-menu__item">
          <Link
            to="/perfil"
            className="f-nav-menu__link"
            activeClassName="--active"
            onClick={toggleButton}
          >
            <img className="f-nav-menu__link__icon" src={iconoPerfil} />
            Perfil
          </Link>
        </li>
        <li className="f-nav-menu__item">
          <Link
            to="/top-jugadoras"
            className="f-nav-menu__link"
            activeClassName="--active"
            onClick={toggleButton}
          >
            <img className="f-nav-menu__link__icon" src={iconoTopJugadoras} />
            Top jugadoras
          </Link>
        </li>
        <li className="f-nav-menu__item">
          <Link
            to="/preguntas-frecuentes"
            className="f-nav-menu__link"
            activeClassName="--active"
            onClick={toggleButton}
          >
            <img
              className="f-nav-menu__link__icon"
              src={iconoPreguntasFrecuentes}
            />
            Preguntas frecuentes
          </Link>
        </li>
      </ul>
    )
  }

  return (
    <nav className="f-nav-menu">
      {isMobile ? (
        <div className="f-nav-menu__hamburguer">
          <HamburgerSpin
            barColor="#fff"
            className={'f-nav-menu__hamburButtom ' + (isActive && '--active')}
            {...{ isActive, toggleButton }}
          />
          <span
            className={
              'f-nav-menu__hamburButtom__spanMenu ' + (isActive && '--active')
            }
          >
            Menú
          </span>
          {
            //menu mobile
            activeMenu && (
              <div className="f-navMenu-mobile-container">{menuOptions()}</div>
            )
          }
        </div>
      ) : (
        menuOptions()
      )}
    </nav>
  )
}

export default NavMenu
